<template>
	<div>
		<div class="d-flex justify-space-between" v-if="asDetail == false">
			<div class="text-h5">Data Riwayat Stok Stockist</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listStockistStockLog" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationStockistStockLog.total_data" class="table-w-120">
				<template v-slot:item.stock_log_datetime="{ item }">
					{{ item.stock_log_datetime | tanggalid }}
				</template>
				<template v-slot:item.stock_in="{ item }">
					<span v-if="item.stock_log_type == 'in'">{{ item.stock_log_value | toNumber }}</span>
					<span v-else>0</span>
				</template>
				<template v-slot:item.stock_out="{ item }">
					<span v-if="item.stock_log_type == 'out'">{{ item.stock_log_value | toNumber }}</span>
					<span v-else>0</span>
				</template>
				<template v-slot:item.stock_balance="{ item }">
					{{ item.stock_balance | toNumber }}
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationStockistStockLog">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationStockistStockLog">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationStockistStockLog.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationStockistStockLog.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'

export default {
	inject: ['theme'],
	components: {
		filterComponent
	},
	props: {
		asDetail: {
			type: Boolean,
			default: false,
		},
		filterDetail: {
			type: Array,
			default: () => [],
		},
		stockistName: {
			type: String,
			default: '',
		}
	},
	data() {
		return {
			sortBy: 'stockist_network_id',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Tanggal', align: 'start', value: 'stock_log_datetime'},
			{ text: 'Kode Stockist', align: 'start', value: 'stockist_code'},
			{ text: 'Nama Stockist', value: 'stockist_name'},
			{ text: 'Nama Produk', value: 'product_name'},
			{ text: 'Kode Produk', value: 'product_code'},
			{ text: 'Stok Masuk', value: 'stock_in'},
			{ text: 'Stok Keluar', value: 'stock_out'},
			{ text: 'Stok Terakhir', value: 'stock_log_last_balance'},
			{ text: 'Keterangan', value: 'stock_log_note'},
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Kode Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_code'
				}
			}, {
				type: 'text',
				label: 'Nama Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_name'
				}
			}, {
				type: 'selection',
				label: 'Produk',
				itemValue: 'product_code',
				itemText: 'product_name',
				item: [],
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'product_code'
				}
			}, {
				type: 'date',
				show: false,
				label: 'Tanggal',
				filter: {
					value: [],
					comparison: 'bet',
					type: 'date',
					field: 'stock_log_datetime'
				}
			}, {
				type: 'text',
				label: 'Keterangan',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stock_log_note'
				}
			}, 
			],
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceStockist', ['listStockistStockLog', 'paginationStockistStockLog']),
	},
	methods: {
		...mapActions('ecommerceStockist', ['getStockistStockLog', 'exportStockistStockLog']),
		...mapActions('ecommerceCommon', ['getOptionProduct']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceStockist', ['clearDataStockist']),

		getData() {
			let params = this.params;
			if (this.filterDetail.length > 0)
				params = [...this.params, ...this.filterDetail]
			this.getStockistStockLog(this.queryString({limit:this.limit, page: this.page, params: params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData() {
			this.exportStockistStockLog(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
	},
	beforeDestroy(){
		if (this.asDetail == false) {
			this.clearDataStockist()
		}
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		let filterData = [];
		if (this.asDetail == false) {
			await this.$store.dispatch('setPageTitle', `Riwayat Stok Stockist Ecommerce`)
			let indexProduct = await this.filterData.findIndex(el => el.label == 'Produk')
			this.filterData[indexProduct].item = await this.getOptionProduct()
			filterData = this.filterData
		} else {
			filterData = this.filterData.filter( el => ['Keterangan', 'Tanggal'].includes(el.label) )
		}
		await this.getData()

		await this.setFilter(filterData)
	},
};
</script>

<style>
